/**************************************************
 * Nombre:       MainDashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra";
import {Route, Routes} from "react-router";

const MainDashboard = ({open, setOpen, masSM, secciones = [], seccionesID = [], seccionesPerfil}) => {

    const getMargen = () => {
        if (masSM) {
            return open ? 34 : 11
        } else {
            return 0
        }
    }

    return (
        <Grid
            container
            size={12}
            sx={{
                pl: getMargen(),
                transition: "all .4s ease-in-out",


            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 2}}>
                <Barra setOpen={setOpen} open={open} seccionesPerfil={seccionesPerfil}/>
            </Grid>


            <Grid container size={12} sx={{pl: masSM ? 4 : 3, pr: 3, marginTop: 10, zIndex: 1}}>

                <Routes>

                    {secciones.map((it, index) => {

                        return (
                            <Route key={`cam-${index}`} path={it.camino}
                                   element={it.Componente}/>
                        )

                    })}


                    {seccionesID.map((it, index) => {
                        return (
                            <Route key={`camid-${index}`} path={it.camino} element={it.Componente}/>
                        )
                    })}

                    {seccionesPerfil.map((it, index) => {
                        return (
                            <Route key={`camidP-${index}`} path={it.camino} element={it.Componente}/>
                        )
                    })}


                </Routes>

            </Grid>

        </Grid>
    )

}
export default MainDashboard